import { MatIconModule } from "@angular/material/icon";

import {
    Component,
    EventEmitter,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
} from "@angular/core";
import { MatRippleModule } from "@angular/material/core";
import { CerrixIconButtonComponent } from "@app/incident/components/src/lib/core/cerrix-icon-button/cerrix-icon-button.component";

@Component({
    selector: "cerrix-paginator",
    templateUrl: "./cerrix-paginator.component.html",
    styleUrls: ["./cerrix-paginator.component.scss"],
    imports: [MatIconModule, MatRippleModule, CerrixIconButtonComponent],
    providers: []
})
export class CerrixPaginatorComponent implements OnInit, OnChanges {
    @Input() public length: number;
    @Input() public pageIndex: number;
    @Input() public pageSize: number;
    @Input() public itemsPerPageLabel: string;

    @Output() public pageIndexChanged: EventEmitter<number> = new EventEmitter<number>();

    protected message: string;
    protected currentPage: number;
    protected lastPage: number;

    ngOnInit(): void {
        this.setPaging();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (
            (changes.length && !changes.length?.firstChange) ||
            (changes.pageIndex && !changes.length?.firstChange) ||
            (changes.pageSize && !changes.length?.firstChange)
        ) {
            this.setPaging();
        }
    }

    private setPaging() {
        if (this.length) {
            this.currentPage = this.pageIndex + 1;
            this.lastPage = Math.ceil(this.length / this.pageSize);

            const from = this.pageIndex * this.pageSize + 1;
            const to = Math.min(from + this.pageSize - 1, this.length);
            const total = this.length;

            this.message = this.itemsPerPageLabel
                .replace("#from#", from.toString())
                .replace("#to#", to.toString())
                .replace("#total#", total.toString());
        }
    }

    protected onLeftRight(changeValue: number) {
        this.pageIndexChanged.emit(this.pageIndex + changeValue);
    }

    protected onPageSelection(value: number) {
        this.pageIndexChanged.emit(value - 1);
    }
}
